var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"pill":"","variant":_vm._f("variantBrand")('customPrimary',this)},on:{"click":_vm.prev}},[_c('i',{staticClass:"mr-2 fas fa-chevron-left"}),_vm._v(" "+_vm._s(_vm.$t('GoBack'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }